import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import DarkVeil from 'src/components/Backgrounds/DarkVeil/DarkVeil';
import TestimonialCarousel, { Testimonial } from './TestimonialCarousel';

/**
 * Demo slots. The copy behind these keys is deliberately marked as a sample in both
 * the quote and the attribution, so neither half can be mistaken for a real customer
 * statement if the other is edited away. Replace both when real quotes are cleared.
 */
const SLOTS = ['one', 'two', 'three'];

/**
 * Decorative column. The gradient lives in CSS rather than in the canvas so that the
 * panel still reads as itself when the shader is skipped — reduced motion, no WebGL, or
 * the column being hidden on narrow screens.
 */
const VeilPanel = () => {
  const { t } = useTranslation('authentication');

  const testimonials = useMemo<Testimonial[]>(
    () =>
      SLOTS.map((slot) => ({
        quote: t(`onboarding.testimonials.${slot}.quote`),
        author: t(`onboarding.testimonials.${slot}.author`),
      })),
    [t]
  );

  return (
    <aside className="onboarding-veil" data-testid="veil-panel">
      <DarkVeil />
      <TestimonialCarousel items={testimonials} />
    </aside>
  );
};

export default VeilPanel;
